import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Moment, GlobalContext } from 'commons';
import { clientTimeZone } from 'utils';

const ItemDate = ({ id, date }) => {
  const { account: { timeZone } } = useContext(GlobalContext);

  return (
    <p className="date" id={`notificationDate${id}`}>
      <span>
        <Moment
          eb-test="ee_notificationList_text_issueTime"
          tz={timeZone || clientTimeZone}
          format="YYYY-MM-DD HH:mm:ss z"
        >
          {date}
        </Moment>
      </span>
    </p>
  );
};

ItemDate.propTypes = {
  id: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
};

export default ItemDate;
